export default {
  /* A getter function that returns the state.profileData. */
  getProfileInfo: (state) => {
    return state.profileData;
  },
};
